import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchEdgeFunction } from '@/services/supabaseClient';
import { useTenant } from '@/hooks/useTenant';

export type GenerateBagLabelResult = {
  shipment_id: string;
  tracking_code: string | null;
  label_url: string | null;
  melhor_envio_id?: string;
  service_name?: string;
  shipping_cost?: number;
};

export const useGenerateBagLabel = (bagId: string) => {
  const queryClient = useQueryClient();
  const { tenant } = useTenant();

  return useMutation({
    mutationFn: async (serviceId: string | number): Promise<GenerateBagLabelResult> => {
      if (!tenant?.id) throw new Error('Tenant não disponível');
      if (!bagId) throw new Error('bagId obrigatório');

      const result = await fetchEdgeFunction('bag-shipping/generate-label', {
        method: 'POST',
        body: JSON.stringify({
          tenant_id: tenant.id,
          bag_id: bagId,
          melhor_envio_service_id: String(serviceId),
        }),
      });

      return result as GenerateBagLabelResult;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bag'] });
      queryClient.invalidateQueries({ queryKey: ['bags'] });
    },
  });
};
